var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarPremium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.187 11.23a.637.637 0 00-.636.636v1.488a.637.637 0 00.636.636h.806a.637.637 0 00.636-.636v-1.488a.637.637 0 00-.636-.636h-.806zM17.097 14.039h-.807a.686.686 0 01-.685-.685v-1.488a.686.686 0 01.685-.686h.807a.686.686 0 01.685.686v1.488a.686.686 0 01-.685.685z",
    fill: "#353535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.562 12.848H2.672c-.632 0-1.146-.373-1.146-.83V9.345l.69-.726h14.937l.555.728v2.67c0 .457-.514.83-1.146.83z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.088 9.957H2.295l-.15-2.306.095-.235.556-1.369h13.69l.752 1.554-.15 2.356z",
    fill: "#EBEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#car-premium_svg__filter0_f_5476_25738)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.735,
    cy: 8.986,
    rx: 2.05,
    ry: 4.156,
    transform: "rotate(-45 9.735 8.986)",
    fill: "#F8F8F8"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.213 7.606l-.11 1.732h-3.255V8.05l3.273-.636.092.19zM5.485 8.051v1.287H2.28l-.11-1.683.093-.23 3.222.626z",
    fill: "#444"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.404 6.443H2.879L4.32 1.634a.965.965 0 01.92-.69l8.957-.086a.97.97 0 01.948.727l1.258 4.858z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.363 5.988L3.918 5.853a.093.093 0 01-.087-.121l1.097-3.423a.092.092 0 01.088-.064h9.205a.092.092 0 01.088.064l1.143 3.559a.092.092 0 01-.047.11.093.093 0 01-.042.01z",
    fill: "#444"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.887 6.344H.858v-.446a.544.544 0 01.544-.544h1.485v.99zM18.425 6.344h-2.028v-.99h1.485a.545.545 0 01.543.544v.446z",
    fill: "#EBEBEB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "car-premium_svg__filter0_f_5476_25738",
    x: 3.188,
    y: 2.44,
    width: 13.093,
    height: 13.093,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.635,
    result: "effect1_foregroundBlur_5476_25738"
  })))));
}
export default __webpack_public_path__ + "static/media/car-premium.a04fffcd.svg";
export { SvgCarPremium as ReactComponent };